// components/strategy/StrategyLoginForm.jsx — Phase 3B individual
// login (email + password + TOTP + country context). Also exposes a
// "code de récupération" fallback link for the MFA-loss path.
import React, { useState } from "react";
import { strategyEndpoints } from "../../lib/strategyApi";

export const StrategyLoginForm = ({ onLoggedIn, onGoToActivate }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [totpCode, setTotpCode] = useState("");
  const [countryCode, setCountryCode] = useState("");
  const [useRecovery, setUseRecovery] = useState(false);
  const [recoveryCode, setRecoveryCode] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setErr("");
    try {
      if (useRecovery) {
        await strategyEndpoints.loginRecovery(email, password, recoveryCode, countryCode);
      } else {
        await strategyEndpoints.login(email, password, totpCode, countryCode);
      }
      onLoggedIn();
    } catch (e) {
      setErr(e?.response?.data?.detail || "Connexion impossible — vérifiez vos identifiants, le code et le pays.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <form onSubmit={submit} className="border-2 border-rescue-ink bg-white p-4 space-y-3" data-testid="strategy-login-form">
      <label className="text-[10px] font-bold tracking-[0.25em] uppercase text-rescue-mute">E-mail</label>
      <input data-testid="strategy-login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)}
        className="w-full border-2 border-rescue-line px-3 py-2 text-sm" autoFocus />
      <label className="text-[10px] font-bold tracking-[0.25em] uppercase text-rescue-mute">Mot de passe</label>
      <input data-testid="strategy-login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)}
        className="w-full border-2 border-rescue-line px-3 py-2 text-sm" />
      <label className="text-[10px] font-bold tracking-[0.25em] uppercase text-rescue-mute">Pays (code)</label>
      <input data-testid="strategy-login-country" value={countryCode} onChange={(e) => setCountryCode(e.target.value.toUpperCase())}
        placeholder="ML" className="w-full border-2 border-rescue-line px-3 py-2 text-sm font-mono" />
      {useRecovery ? (
        <>
          <label className="text-[10px] font-bold tracking-[0.25em] uppercase text-rescue-mute">Code de récupération</label>
          <input data-testid="strategy-login-recovery-code" value={recoveryCode} onChange={(e) => setRecoveryCode(e.target.value)}
            className="w-full border-2 border-rescue-line px-3 py-2 text-sm font-mono" />
        </>
      ) : (
        <>
          <label className="text-[10px] font-bold tracking-[0.25em] uppercase text-rescue-mute">Code MFA (TOTP)</label>
          <input data-testid="strategy-login-totp" value={totpCode} onChange={(e) => setTotpCode(e.target.value)}
            placeholder="123456" className="w-full border-2 border-rescue-line px-3 py-2 text-sm font-mono tracking-widest" />
        </>
      )}
      {err && <div className="text-xs text-rescue-red font-bold" data-testid="strategy-login-error">{err}</div>}
      <button type="submit" disabled={submitting} data-testid="strategy-login-submit"
        className="w-full bg-rescue-red text-white py-3 text-xs font-bold uppercase tracking-[0.2em] disabled:opacity-60">
        {submitting ? "Connexion…" : "Se connecter"}
      </button>
      <div className="flex items-center justify-between pt-1">
        <button type="button" data-testid="strategy-toggle-recovery" onClick={() => setUseRecovery((v) => !v)}
          className="text-[10px] font-bold uppercase tracking-[0.2em] text-rescue-mute hover:text-rescue-ink">
          {useRecovery ? "← Revenir au code MFA" : "Perdu l'accès au MFA ?"}
        </button>
        <button type="button" data-testid="strategy-go-to-activate" onClick={onGoToActivate}
          className="text-[10px] font-bold uppercase tracking-[0.2em] text-rescue-mute hover:text-rescue-ink">
          J'ai un lien d'activation →
        </button>
      </div>
    </form>
  );
};
